import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-ind-app-numbers',
  templateUrl: './ind-app-numbers.component.html',
  styleUrls: ['./ind-app-numbers.component.scss']
})
export class IndAppNumbersComponent implements OnInit {
  @ViewChild('indApplicationNumbersInput') indApplicationNumbersInput!: ElementRef;
  indApplicationNumbers!: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.indApplicationNumbers = this.currentForm.get('indApplicationNumbers')?.value;
  }

  public clearIndApplicationNumbersInputField() {
    this.indApplicationNumbers = '';
    this.formService.updateUsanFormValue('indApplicationNumbers', this.indApplicationNumbers);
    this.errorCheck();
  }

  public updateIndApplicationNumbers(event: Event) {
    if (event && event.type === 'blur') {
      var target = document.activeElement;
      if (target && target.nodeValue === "cancel") {
        this.indApplicationNumbers = '';
      }
    }
    this.formService.updateUsanFormValue('indApplicationNumbers', this.indApplicationNumbers);
    this.errorCheck();
  }

  public cancelUpdate() {
    this.indApplicationNumbers = this.currentForm.get('indApplicationNumbers')?.value;
    this.errorCheck();
  }

  private errorCheck() {
    const targetControl = this.currentForm.get('indApplicationNumbers');
    
    if(!targetControl) {
      return;
    }

    // Force re-validation
    setTimeout(() => {
      targetControl.markAsTouched();
      targetControl.markAsDirty();
      targetControl.updateValueAndValidity();
    });
  }

  public hasFieldValidationError(fieldName: string, errorName?: string): boolean {
    return this.formService.hasFieldValidationError(fieldName, errorName);
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
